import React from 'react';
import Tooltip from '../toolTip';
import { RadioButtonProps } from '../../types/buttons.type';

export default function RadioButton({
  value, checked, onChange, label, disabled, tooltip, name, children,
}: RadioButtonProps) {
  return (
    <label
      htmlFor={value}
      className={`button-radio select-none border ${checked ? 'border-[#096] bg-white' : ' border-pie-chart-slice2'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <input
        id={value}
        name={name}
        type="radio"
        className="accent-[#096] w-4 h-4 outline-pie-chart-slice2"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
      />
      <div className="flex flex-col gap-2 w-full">
        <span className="text-secondary">{label}</span>
        {tooltip && <Tooltip text={tooltip} label={label} />}
        {children}
      </div>
    </label>
  );
}
